import { Box, styled } from '@mui/material';

const StepperCoords = styled(Box)`
  font-weight: normal;
  font-size: 0.8rem;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export default StepperCoords;
